/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { PntAppControllerGetSegmentAdOverlayByDateQueryResponse, PntAppControllerGetSegmentAdOverlayByDatePathParams, PntAppControllerGetSegmentAdOverlayByDateQueryParams } from "../models/PntAppControllerGetSegmentAdOverlayByDate";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { pntAppControllerGetSegmentAdOverlayByDate } from "../axios/pntAppControllerGetSegmentAdOverlayByDate";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const pntAppControllerGetSegmentAdOverlayByDateQueryKey = (slug: PntAppControllerGetSegmentAdOverlayByDatePathParams["slug"], params: PntAppControllerGetSegmentAdOverlayByDateQueryParams) => ["api-v2", { url: '/pnt/v2/segments/:slug/adoverlay', params: {slug:slug} }, ...(params ? [params] : [])] as const

export type PntAppControllerGetSegmentAdOverlayByDateQueryKey = ReturnType<typeof pntAppControllerGetSegmentAdOverlayByDateQueryKey>

export function pntAppControllerGetSegmentAdOverlayByDateQueryOptions(slug: PntAppControllerGetSegmentAdOverlayByDatePathParams["slug"], params: PntAppControllerGetSegmentAdOverlayByDateQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = pntAppControllerGetSegmentAdOverlayByDateQueryKey(slug, params)
        return queryOptions<PntAppControllerGetSegmentAdOverlayByDateQueryResponse, ResponseErrorConfig<Error>, PntAppControllerGetSegmentAdOverlayByDateQueryResponse, typeof queryKey>({
         enabled: !!(slug&& params),
         queryKey,
         queryFn: async ({ signal }) => {
            return pntAppControllerGetSegmentAdOverlayByDate(slug, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Retrieve the ad overlays for a time range
 * {@link /pnt/v2/segments/:slug/adoverlay}
 */
export function usePntAppControllerGetSegmentAdOverlayByDate<TData = PntAppControllerGetSegmentAdOverlayByDateQueryResponse, TQueryData = PntAppControllerGetSegmentAdOverlayByDateQueryResponse, TQueryKey extends QueryKey = PntAppControllerGetSegmentAdOverlayByDateQueryKey>(slug: PntAppControllerGetSegmentAdOverlayByDatePathParams["slug"], params: PntAppControllerGetSegmentAdOverlayByDateQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PntAppControllerGetSegmentAdOverlayByDateQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? pntAppControllerGetSegmentAdOverlayByDateQueryKey(slug, params)
         

         const query = useQuery({
          ...pntAppControllerGetSegmentAdOverlayByDateQueryOptions(slug, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}